import request from '@/utils/request'

/**
 * 查询设备列表
 * @param parameter
 */
export function getListDustNoiseDevice (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/listDustNoiseDevice`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询设备列表（固定顺序）
 * @param parameter
 */
export function getListDevice (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/deviceList`,
    method: 'get',
    params: parameter
  })
}

/**
 * 删除设备
 * @param parameter
 */
export function deleteDustNoiseDeviceById (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/deleteDustNoiseDeviceById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 查询详情
 * @param parameter
 */
export function getDustNoiseDeviceById (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/getDustNoiseDeviceById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 查询扬尘噪音预警列表
 * @param parameter
 */
export function getListDustNoiseWarn (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseWarn/listDustNoiseWarn`,
    method: 'get',
    params: parameter
  })
}

/**
 * 保存设备
 * @param parameter
 */
export function saveDustNoiseDevice (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/saveDustNoiseDevice`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改扬尘噪音设备表
 * @param parameter
 */
export function updateDustNoiseDevice (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/updateDustNoiseDevice`,
    method: 'put',
    data: parameter
  })
}

/**
 * 保存扬尘噪音预警
 * @param parameter
 */
export function saveDustNoiseWarn (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseWarn/saveDustNoiseWarn`,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询扬尘噪音预警推送人列表
 * @param parameter
 */
export function getListWarnPush (parameter) {
  return request({
    url: `/AY220052Z/WarnPush/listWarnPush`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改扬尘噪音预警
 * @param parameter
 */
export function updateDustNoiseWarn (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseWarn/updateDustNoiseWarn`,
    method: 'put',
    data: parameter
  })
}

/**
 * 保存扬尘噪音预警推送人
 * @param parameter
 */
export function saveWarnPush (parameter) {
  return request({
    url: `/AY220052Z/WarnPush/saveWarnPush`,
    method: 'post',
    data: parameter
  })
}

/**
 * 扬尘噪音检测项统计分析
 * @param parameter
 */
export function getDustNoiseGraph (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/getDustNoiseGraph`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询告警记录列表
 * @param parameter
 */
export function getListAlarmRecord (parameter) {
  return request({
    url: `/AY220052Z/AlarmRecord/listAlarmRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * 扬尘噪声数据记录
 * @param parameter
 */
export function getListDustNoiseData (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/listDustNoiseData`,
    method: 'get',
    params: parameter
  })
}

/**
 * 扬尘噪声恢复
 * @param parameter
 */
export function dustNoiseRecover (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/dustNoiseRecover`,
    method: 'get',
    params: parameter
  })
}

/**
 * 扬尘噪声恢复
 * @param parameter
 */
export function dustNoiseUpdate (parameter) {
  return request({
    url: `/AY220052Z/DustNoiseDevice/dustNoiseUpdate`,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询设备列表
 * @param parameter
 */
export function getListSurroundSprayDevice (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayDevice/listSurroundSprayDevice`,
    method: 'get',
    params: parameter
  })
}

/**
 * 删除设备
 * @param parameter
 */
export function deleteSurroundSprayDeviceById (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayDevice/deleteSurroundSprayDeviceById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存围挡喷淋设备表
 * @param parameter
 */
export function saveSurroundSprayDevice (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayDevice/saveSurroundSprayDevice`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改围挡喷淋设备表
 * @param parameter
 */
export function updateSurroundSprayDevice (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayDevice/updateSurroundSprayDevice`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询围挡喷淋设备表详情
 * @param parameter
 */
export function getSurroundSprayDeviceById (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayDevice/getSurroundSprayDeviceById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 查询围挡喷淋定时喷淋表列表
 * @param parameter
 */
export function getListSurroundSprayTimed (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayTimed/listSurroundSprayTimed`,
    method: 'get',
    params: parameter
  })
}

/**
 * 保存围挡喷淋定时喷淋表
 * @param parameter
 */
export function saveSurroundSprayTimed (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayTimed/saveSurroundSprayTimed`,
    method: 'post',
    data: parameter
  })
}

/**
 * 删除设备
 * @param parameter
 */
export function deleteSurroundSprayTimedById (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayTimed/deleteSurroundSprayTimedById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 围挡喷淋运行数据统计
 * @param parameter
 */
export function getSurroundSprayGraph (parameter) {
  return request({
    url: `/AY220052Z/SurroundSprayDevice/getSurroundSprayGraph`,
    method: 'get',
    params: parameter
  })
}

/**
 * 人员花名册列表
 * @param parameter
 */
export function getLaborRosterList (parameter) {
  return request({
    url: `/user/User/rosterList`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【组织管理】组织树
 * @param {object} parameter
 * @property {String} orgId 组织id
 */
export function listOrgTree (parameter) {
  return request({
    url: `/org/Organization/ListOrgTree`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询历史天气记录列表
 * @param parameter
 */
export function getListWeatherRecord (parameter) {
  return request({
    url: `/org/WeatherRecord/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询风速实时值
 * @param parameter
 */
export function getWindSpeedRealTime (parameter) {
  return request({
    url: `/AY220052Z/WindSpeed/getWindSpeedRealTime`,
    method: 'get',
    params: parameter,
    timeout: 1000 * 60 * 3
  })
}

/**
 * 历史数据
 * @param parameter
 */
export function getWindSpeedHistoryList (parameter) {
  return request({
    url: `/AY220052Z/WindSpeed/listWindSpeedHistory`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询风速预警记录列表
 * @param parameter
 */
export function getWindSpeedWarnRecordList (parameter) {
  return request({
    url: `/AY220052Z/WindSpeed/listWindSpeedWarnRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询监测数据
 * @param parameter
 */
export function getMonitoringWindSpeedData (parameter) {
  return request({
    url: `/AY220052Z/WindSpeed/monitoringWindSpeedData`,
    method: 'get',
    params: parameter,
    timeout: 1000 * 60 * 3
  })
}

/**
 * 查询风速预警设置详情
 * @param parameter
 */
export function getWindSpeedWarnById (parameter) {
  return request({
    url: `/AY220052Z/WindSpeedWarn/getWindSpeedWarnById/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 保存风速预警设置
 * @param parameter
 */
export function saveOrUpdateWindSpeedWarn (parameter) {
  return request({
    url: `/AY220052Z/WindSpeedWarn/saveOrUpdateWindSpeedWarn`,
    method: 'post',
    data: parameter
  })
}
